import {gsap} from "./gsap";
import {isWebview} from "./utils";

export default class ThemeChanger {

    dataThemeBelow;
    themeObserver;
    watcherInterval;
    bgCtx;

    constructor() {

        this.bgCtx = this.queryContext();
        this.pageTheme = () => document.querySelector("#main")?.dataset.pageTheme;
        this.initializeBackgroundColor();
        this.initializeThemeObserver();
        this.observeThemeChangers();
        this.initializeThemeWatcher();

    }

    initializeBackgroundColor() {
        this.bgCtx.forEach(ctx=>{
            ctx.fillStyle = this.paperColor;
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)
        });
    }

    initializeThemeObserver() {
        this.themeObserver = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    let isScrollingDown = true;
        
                    if (entry.target.lastIntersectionY !== undefined) {
                        isScrollingDown = entry.target.lastIntersectionY > entry.boundingClientRect.y;
                    }
        
                    entry.target.lastIntersectionY = entry.boundingClientRect.y;
        
                    if (entry.isIntersecting) {
                        if (isScrollingDown) {
                            this.updatePageTheme(entry.target.dataset.themeBelow);
                        } else {
                            this.updatePageTheme(entry.target.dataset.themeAbove);
                        }
                    }
                });
            },
            {
                rootMargin: "-50%",
                threshold: 0,
            }
        );
    }

    initializeThemeWatcher() {
        this.setThemeBasedOnScrollPosition();
        clearInterval(this.watcherInterval);
        this.watcherInterval = setInterval( () => requestAnimationFrame(this.setThemeBasedOnScrollPosition.bind(this)), 1000 );
    }

    stopObserving() {
        this.themeObserver.disconnect();
    }

    observeThemeChangers() {
        this.stopObserving();
        
        this.dataThemeBelow = document.documentElement.querySelectorAll("[data-theme-below]");

        this.dataThemeBelow.forEach((changer, index) => {

            let sibling = index ? this.dataThemeBelow[index - 1] : null;
            let foundSibling = false;

            while (sibling) {
                if (sibling.matches && sibling.matches('[data-theme-below]')) {
                    changer.dataset.themeAbove = sibling.dataset.themeBelow;
                    foundSibling = true;
                    sibling = null;
                } else {
                    sibling = sibling.previousSibling;
                }
            }

            if (!foundSibling) {
                changer.dataset.themeAbove = this.pageTheme() ?? document.body.dataset.theme ?? document.documentElement.dataset.theme;
            }

            this.themeObserver.observe(changer);
        });
    }

    updatePageTheme( theme ) {
        if( document.body.dataset.theme !== theme ) {
            document.body.dataset.theme = theme;
            this.bgCtx.forEach(ctx=>{
                if(this.paperColor){
                    this.gsapUpdateCanvas(ctx);
                }
                else {
                    setTimeout(() => {
                        this.gsapUpdateCanvas(ctx);
                    }, 1000);
                }
            })
        }
    }

    gsapUpdateCanvas(ctx) {
        gsap.to(ctx, {
            fillStyle: this.paperColor,
            duration: 0.8,
            onUpdate() {
                ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            }
        })
    }

    setThemeBasedOnScrollPosition() {
        const scrollPosition = window.scrollY + (window.innerHeight * .4);
        const beforeThemes = [...this.dataThemeBelow].filter( th => th.offsetTop < scrollPosition );
        if( beforeThemes.length > 0 ) {
            const theme = beforeThemes[beforeThemes.length-1];
            if( scrollPosition - theme.offsetTop > 200 ) {
                this.updatePageTheme(theme.dataset.themeBelow);
            }
        } else {
            this.updatePageTheme( this.pageTheme() ?? document.body.dataset.topTheme ?? document.documentElement.dataset.theme);
        }
    }

    queryContext() {
        return [...document.querySelectorAll('canvas.background')].map(el=>{
            return el.getContext("2d", {
                alpha: false,
                desynchronized: !isWebview(),
            })
        })
    }


    get paperColor() {
        return getComputedStyle(document.body).getPropertyValue('--paper');
    }

}

// const paperColor = getComputedStyle(document.body).getPropertyValue('--paper');

// bgCtx.forEach(ctx=>{
//     ctx.fillStyle = paperColor;
//     ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)
// });

// const themeObserver = new IntersectionObserver(
//     (entries, observer) => {
//         entries.forEach((entry) => {
//             let isScrollingDown = true;

//             if (entry.target.lastIntersectionY !== undefined) {
//                 isScrollingDown = entry.target.lastIntersectionY > entry.boundingClientRect.y;
//             }

//             entry.target.lastIntersectionY = entry.boundingClientRect.y;

//             if (entry.isIntersecting) {
//                 if (isScrollingDown) {
//                     updatePageTheme(entry.target.dataset.themeBelow);
//                 } else {
//                     updatePageTheme(entry.target.dataset.themeAbove);
//                 }
//             }
//         });
//     },
//     {
//         rootMargin: "-50%",
//         threshold: 0,
//     }
// );

// const dataThemeBelow = document.documentElement.querySelectorAll("[data-theme-below]")


// dataThemeBelow.forEach((changer, index) => {

//     let sibling = index ? dataThemeBelow[index - 1] : null;
//     let foundSibling = false;

//     while (sibling) {
//         if (sibling.matches && sibling.matches('[data-theme-below]')) {
//             changer.dataset.themeAbove = sibling.dataset.themeBelow;
//             foundSibling = true;
//             sibling = null;
//         } else {
//             sibling = sibling.previousSibling;
//         }
//     }

//     if (!foundSibling) {
//         changer.dataset.themeAbove = document.body.dataset.theme ?? document.documentElement.dataset.theme;
//     }

//     themeObserver.observe(changer);
// });

// function updatePageTheme( theme ) {
//     if( document.body.dataset.theme !== theme ) {
//         document.body.dataset.theme = theme;
//         const paperColor = getComputedStyle(document.body).getPropertyValue('--paper');
//         bgCtx.forEach(ctx=>{
//             gsap.to(ctx, {
//                 fillStyle: paperColor,
//                 duration: 0.8,
//                 onUpdate() {
//                     ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//                 }
//             })
//         })
//     }
// }


//This is a back-up function to update the theme at any time (in case intersectionObserver misses one)
// function setThemeBasedOnScrollPosition() {
//     const scrollPosition = window.scrollY + (window.innerHeight * .4);
//     const beforeThemes = [...dataThemeBelow].filter( th => th.offsetTop < scrollPosition );
//     if( beforeThemes.length > 0 ) {
//         const theme = beforeThemes[beforeThemes.length-1];
//         if( scrollPosition - theme.offsetTop > 200 ) {
//             updatePageTheme(theme.dataset.themeBelow);
//         }
//     } else {
//         updatePageTheme(document.documentElement.dataset.theme);
//     }
// }

// setThemeBasedOnScrollPosition();
// setInterval( () => requestAnimationFrame(setThemeBasedOnScrollPosition), 1000 );